<template>
  <base-page-layout :hideBreadcrumbs="false" showBackButton backRouter="/produtos/gerenciamento-produtos/produtos-loja">
    <mf-loading-dialog :loading="isProductLoading" />
    <div v-if="!isProductLoading">
      <v-row class="px-3 pb-4">
        <h2 class="ma-0 page-title">{{ product.name }}</h2>
        <product-chips :product-forms="product" :is-create="isCreate"></product-chips>
        <v-spacer></v-spacer>
        <div v-if="!isCreate" class="pl-2 pr-1 d-flex align-center justify-center" :class="product.active ? 'active-item' : 'inactive-item'">
          <span>{{ product.active ? 'Produto ativo' : 'Produto inativo' }}</span>
          <mf-toggle v-model="product.active" class="ml-4" hide-details />
        </div>
      </v-row>
      <div>
        <product-store-detail v-model="product" :validation="$v" :is-create="isCreate" />
        <product-store-info v-model="product" :validation="$v" :is-create="isCreate" />
        <product-store-price v-if="$getLoggedUser().has_ecommerce" v-model="product" :validation="$v" :is-create="isCreate" />
        <product-store-stock v-if="$getLoggedUser().has_ecommerce" v-model="product" :is-create="isCreate" :validation="$v" />
        <product-store-exhibition v-if="$getLoggedUser().has_ecommerce" v-model="product" />
        <product-variations v-if="$getLoggedUser().has_ecommerce" v-model="product" :validation="$v" />
      </div>
      <v-row class="py-8 px-4">
        <mf-button outlined label="Cancelar" @click="$router.push('/produtos/gerenciamento-produtos/produtos-loja')" />
        <v-spacer></v-spacer>
        <mf-button class="mr-3" label="Salvar e continuar" outlined :disabled="loading" @click="checkForm(true)" />
        <mf-button label="Salvar e sair" :disabled="loading" @click="checkForm" />
      </v-row>
    </div>
  </base-page-layout>
</template>

<script>
import { required, maxLength, minLength, requiredIf } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { QUERY_GET_PRODUCT_STORE_BY_ID, MUTATION_CREATE_PRODUCT_STORE, MUTATION_UPDATE_PRODUCT_STORE } from '../../../graphql'

export default {
  name: 'CreateEditProductStore',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    ProductStoreDetail: () => import('./ProductStoreDetail.vue'),
    ProductStoreInfo: () => import('./ProductStoreInfo.vue'),
    ProductStorePrice: () => import('./ProductStorePrice.vue'),
    ProductStoreStock: () => import('./ProductStoreStock.vue'),
    ProductStoreExhibition: () => import('./ProductStoreExhibition.vue'),
    ProductVariations: () => import('../../components/ProductVariations.vue'),
    ProductChips: () => import('../../components/ProductChips.vue'),
  },
  data: () => ({
    isProductLoading: false,
    isCreate: false,
    loading: false,
    forcePush: false,
    product: {
      active: true,
      ecommerceId: '',
      ecommerceStoreId: '',
      ecommerceProductId: null,
      sku: '',
      dueDate: '',
      name: '',
      stock: 0,
      stockBreak: 0,
      price1: 0,
      order: 99,
      storeId: '',
      store: {
        id: '',
        name: '',
      },
      product: {
        name: '',
      },
      eans: [],
      sales: [
        {
          active: true,
          discount: 0,
          maximumLimit: 0,
          minimumLimit: 0,
          price1: '',
          price2: 0,
          typeEcommerce: 'preco1',
          type: 'general',
        },
        {
          active: false,
          discount: 0,
          maximumLimit: 0,
          minimumLimit: 0,
          price1: 0,
          price2: 0,
          typeEcommerce: 'preco_com_desconto',
          type: 'general',
        },
        {
          active: false,
          discount: 0,
          maximumLimit: 0,
          minimumLimit: 0,
          price1: 0,
          price2: 0,
          typeEcommerce: 'preco_clube',
          type: 'general',
        },
        {
          active: false,
          discount: 0,
          maximumLimit: 0,
          minimumLimit: 0,
          price1: 0,
          price2: 0,
          typeEcommerce: 'preco_atacado',
          type: 'general',
        },
      ],
      variations: [],
    },
    salesTypes: ['preco1', 'preco_com_desconto', 'preco_clube', 'preco_atacado'],
  }),
  provide: function () {
    return {
      userHasPermission: true,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    if (this.$route.params.id) {
      this.getProductById(this.$route.params.id)
    } else {
      this.isCreate = true
    }
  },
  methods: {
    async getProductById(id) {
      try {
        this.isProductLoading = true

        const {
          data: { storeProductById },
        } = await this.$apollo.query({
          query: QUERY_GET_PRODUCT_STORE_BY_ID,
          variables: { storeProductById: id },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })

        const product = structuredClone(storeProductById)
        if (product.sales.length < 4) {
          this.salesTypes.forEach((saleType) => {
            if (!storeProductById.sales.some((sale) => sale.typeEcommerce === saleType)) {
              product.sales.push({
                active: saleType === 'preco1',
                discount: 0,
                maximumLimit: 0,
                minimumLimit: 0,
                price1: 0,
                price2: 0,
                typeEcommerce: saleType,
              })
            }
          })
        }

        this.productFormat(product)
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produto', snackbarColor: 'error' })
      } finally {
        this.isProductLoading = false
      }
    },
    productFormat(storeProductById) {
      this.product = storeProductById
      this.product.manuallyEdited = storeProductById.createdManually
      if (!storeProductById.product.images) {
        this.product.product.images = [
          {
            isMain: true,
            url: '',
            urlThumbnail: '',
            urlMiniature: '',
            order: '',
          },
        ]
      }
    },
    checkForm(stayScreen) {
      this.$v.$touch()

      if (this.$v.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        this.scrollWindowToError('.error--text')

        return
      }

      this.formatBeforeSave(stayScreen)
    },
    formatBeforeSave(stayScreen) {
      const formattedProduct = structuredClone(this.product)
      this.forcePush = true
      delete formattedProduct.manuallyEdited
      delete formattedProduct.createdManually
      formattedProduct.eans.forEach((ean) => {
        ean.ean = ean.ean.toString()

        if (ean.packingQuantity.quantityPackaging) {
          ean.packingQuantity.quantityPackaging = ean.packingQuantity.quantityPackaging.toString()
        }
      })
      if (typeof formattedProduct.price1 === 'string') {
        formattedProduct.price1 = parseFloat(formattedProduct.price1.replace(/\./g, '').replace(',', '.'))
      }
      if (typeof formattedProduct.stock === 'string') {
        formattedProduct.stock = parseFloat(formattedProduct.stock.replace(/\./g, '').replace(',', '.'))
      }
      if (typeof formattedProduct.stockBreak === 'string') {
        formattedProduct.stockBreak = parseFloat(formattedProduct.stockBreak.replace(/\./g, '').replace(',', '.'))
      }
      formattedProduct.productId = formattedProduct.product.id
      formattedProduct.sales[this.getSalesIndex('preco_com_desconto')].active = formattedProduct.sales[this.getSalesIndex('preco_com_desconto')].price2 !== 0
      formattedProduct.eans.forEach((ean) => {
        ean.ean = ean.ean.toString()
      })
      const attr = ['discount', 'minimumLimit', 'maximumLimit', 'price1', 'price2']
      formattedProduct.sales.forEach((item) => {
        attr.forEach((i) => {
          if (item[i] && typeof item[i] === 'string') {
            item[i] = parseFloat(item[i].replace(/\./g, '').replace(',', '.'))
          }
        })
      })
      this.salesTypes.forEach((type) => {
        formattedProduct.sales[this.getSalesIndex(type)].price1 = formattedProduct.price1
      })
      if (this.isCreate) {
        formattedProduct.productId = formattedProduct.product.id
        formattedProduct.sku = formattedProduct.sku.toString()
        delete formattedProduct.store
        delete formattedProduct.product

        this.createProduct(formattedProduct, stayScreen)

        return
      }

      formattedProduct.eans.forEach((ean) => {
        delete ean.__typename
        delete ean.packingQuantity.__typename
      })
      formattedProduct.variations.forEach((variation) => {
        delete variation.__typename
      })

      if (formattedProduct.variations.length && !formattedProduct.variations.some((variation) => variation.isDefault)) {
        formattedProduct.variations[0].isDefault = true
      }
      formattedProduct.sales.forEach((item) => {
        item.type = item.type ? item.type : 'general'
        delete item.__typename
      })
      delete formattedProduct.__typename
      delete formattedProduct.product
      delete formattedProduct.store
      delete formattedProduct.erpCategories

      this.updateProduct(formattedProduct, stayScreen)
    },
    createProduct(product, stayScreen) {
      this.loading = true
      this.$apollo
        .mutate({
          mutation: MUTATION_CREATE_PRODUCT_STORE,
          variables: {
            data: product,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          this.$snackbar({ message: 'Produto criado com sucesso.', snackbarColor: 'success' })

          if (stayScreen) {
            this.$router.push({ path: `/produtos/alterar-produto-loja/${data.createStoreProduct.id}` }).then(() => {
              window.location.reload()
            })
          } else {
            this.$router.push('/produtos/gerenciamento-produtos/produtos-loja')
          }
        })
        .catch((error) => {
          return this.errorSnackbar(error)
        })
        .finally(() => (this.loading = false))
    },
    errorSnackbar(error) {
      if (error.message.indexOf('Store Product With Same Product Id Already Exist Error') !== -1) {
        this.$snackbar({
          message: 'Já existe um produto loja vinculado a um produto modelo.',
          snackbarColor: 'error',
        })
        return
      }
      if (error.message.indexOf('Store Product With Same Ean Already Exist Error') !== -1) {
        this.$snackbar({
          message: 'Já existe um EAN vinculado a um produto loja.',
          snackbarColor: 'error',
        })
        return
      }
      if (error.message.indexOf('Store Product With Same Sku Already Exist Error') !== -1) {
        this.$snackbar({
          message: 'Já existe um SKU vinculado a um produto loja.',
          snackbarColor: 'error',
        })
        return
      }
      return this.$snackbar({ message: 'Erro ao criar produto.', snackbarColor: 'error' })
    },
    updateProduct(product, stayScreen) {
      this.loading = true

      this.$apollo
        .mutate({
          mutation: MUTATION_UPDATE_PRODUCT_STORE,
          variables: {
            data: product,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then((data) => {
          this.$snackbar({ message: 'Produto editado com sucesso.', snackbarColor: 'success' })
          if (stayScreen) {
            window.location.reload()
          } else {
            this.$router.push('/produtos/gerenciamento-produtos/produtos-loja')
          }
        })
        .catch((error) => {
          return this.errorSnackbar(error)
        })
        .finally(() => (this.loading = false))
    },
    scrollWindowToError(querySelector) {
      this.$nextTick(() => {
        let element = document.querySelector(querySelector)
        if (element) {
          this.$vuetify.goTo(element, { offset: 200 })
        } else {
          window.scrollTo(0, 0)
        }
      })
    },
    changeProductActive() {
      this.product.active = !this.product.active
    },
    getSalesIndex(salesType) {
      const position = this.product.sales.findIndex((sale) => sale.typeEcommerce === salesType)

      return position >= 0 ? position : this.product.sales.length + 1
    },
  },
  validations() {
    const product = {
      sku: {
        required,
        maxLength: maxLength(14),
      },
      name: {
        required,
        minValue: minLength(1),
        maxLength: maxLength(255),
        notOnlySpace,
      },
      storeId: {
        required,
      },
      eans: {
        required,
        minLength: minLength(1),
        $each: {
          ean: {
            required,
          },
        },
      },
      stock: {
        required,
      },
      stockBreak: {
        required,
        isLessThanStock: function (value) {
          let stockBreak = value.toString().replace(/\./g, '').replace(',', '.')
          let stock = this.product.stock.replace(/\./g, '').replace(',', '.')

          let parsedStockBreak = parseFloat(stockBreak)
          let parsedStock = parseFloat(stock)

          return parsedStockBreak <= parsedStock
        },
      },
    }

    if (this.product.variations && this.product.variations.length) {
      product.variations = {
        $each: {
          name: {
            maxLength: maxLength(30),
            required,
            notOnlySpace,
          },
          percentage: {
            required,
          },
          isDefault: function () {
            return this.product.variations.some((variation) => variation.isDefault)
          },
        },
      }
    }
    product.product = {
      name: {
        required,
        notOnlySpace,
      },
    }

    product.price1 = {
      minValue: function (value) {
        const newValue = value.replace(/\./g, '').replace(',', '.')
        const formattedValue = parseFloat(newValue).toFixed(2)

        return formattedValue > 0
      },
    }

    product.sales = {
      $each: {
        maximumLimit: {
          required: requiredIf(function (sale) {
            return sale.typeEcommerce === 'preco1'
          }),
        },
        minimumLimit: {
          required: requiredIf(function (sale) {
            return sale.typeEcommerce === 'preco_atacado' && this.product.sales[this.getSalesIndex('preco_atacado')].active
          }),
          isZero: function (value, sale) {
            if (sale.typeEcommerce === 'preco_atacado' && this.product.sales[this.getSalesIndex('preco_atacado')].active) {
              return !(value === 0)
            }
            return true
          },
        },
        price2: {
          required: requiredIf(function (sale) {
            return sale.typeEcommerce === 'preco_atacado' && this.product.sales[this.getSalesIndex('preco_atacado')].active
          }),
          isLessThanPrice: function (value, sale) {
            if (
              (sale.typeEcommerce === 'preco_atacado' && this.product.sales[this.getSalesIndex('preco_atacado')].active) ||
              sale.typeEcommerce === 'preco_com_desconto'
            ) {
              let newValue = value.toString().replace(/\./g, '').replace(',', '.')
              let newPrice = this.product.price1.replace(/\./g, '').replace(',', '.')

              let parsedNewValue = parseFloat(newValue)
              let parsedNewPrice = parseFloat(newPrice)

              return parsedNewValue <= parsedNewPrice
            }
            return true
          },
          isZero: function (value, sale) {
            if (sale.typeEcommerce === 'preco_atacado' && this.product.sales[this.getSalesIndex('preco_atacado')].active) {
              return !(value === '0,00' || value === 0)
            }
            return true
          },
        },
      },
    }

    return { product }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.forcePush) {
      this.$confirm({
        title: 'Tem certeza?',
        message: 'Suas alterações ainda não foram salvas e todas as suas alterações recentes serão perdidas ao sair dessa página.',
        confirmText: this.isCreate ? 'Ficar e continuar criação' : 'Ficar e continuar edição',
        cancelText: 'Sair da tela',
      })
        .then(() => {
          next(false)
        })
        .catch(() => {
          next()
        })
    } else {
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
.card-title-variations {
  color: $cinza-d10;
  font-weight: 700;
}
.active-item {
  border: 1px solid $marca-1;
  border-radius: 6px;
  height: 40px;
  ::v-deep .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
}
.inactive-item {
  border: 1px solid $cinza-l40;
  border-radius: 6px;
  height: 40px;
  ::v-deep .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
